/**
 * ソート管理の定数列挙クラス
 */


  /**
  * コミュニケーション（部屋並び）
  * @param id ID
  * @param value ソートする値
  * @param label ラベル
  * @param orderBy 昇順/降順
  */
const _roomSortsEnum = [
  { "id": 1, "value": "created_at", "label": '新しいルーム順' , "orderBy" : "desc"},
  { "id": 2, "value": "commented_at", "label": '最新コメント順' , "orderBy" : "desc"},
  { "id": 3, "value": "name" , "label" : 'ルーム名昇順' , "orderBy" : "asc"},
  { "id": 4, "value": "name" , "label": 'ルーム名降順' , "orderBy" : "desc"},
]

export default {
  data () {
    return {
      roomSorts: _roomSortsEnum,
    }
  }
}
